import React from 'react';
import NumberFormat, { NumberFormatProps, NumberFormatValues } from 'react-number-format';

interface MaskProps extends NumberFormatProps {
  onChange: (event: { target: { value: string } }) => void;
}

export const CurrencyMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      isNumericString
      maxLength={13}
    />
  );
});

export const DigitCodeMax4 = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      isNumericString
      format="####"
      onValueChange={(values) => {
        const paddedValue = values.value.padEnd(4, '0');

        onChange({
          target: {
            value: paddedValue
          }
        });
      }}
      mask="_"
    />
  );
});

export const CurrencyMask4Decimal = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={4}
      isNumericString
      maxLength={15}
    />
  );
});

export const CurrencyMask6Decimal = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={6}
      isNumericString
      maxLength={13}
    />
  );
});

export const CurrencyMask20Decimal = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={20}
      isNumericString
      maxLength={30}
    />
  );
});

export const NumberMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;

  const isAllowed = (values: NumberFormatValues) => {
    const regex = /^\d*$/;
    return regex.test(values.value);
  };

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      isAllowed={isAllowed}
      isNumericString
    />
  );
});

/** Inteiro com sinal; `allowNegative={false}` restringe a positivos. */
export const IntegerMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;

  const isAllowed = (values: NumberFormatValues) => /^-?\d*$/.test(values.value);

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      isAllowed={isAllowed}
      decimalScale={0}
      isNumericString
    />
  );
});

export const PhoneMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      isNumericString
      format="(##) #####-####"
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      mask="_"
    />
  );
});

export const DocumentMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;

  const formatCPFOrCNPJ = (rawValue: string) => {
    const cleanedValue = rawValue.replace(/[^\d]/g, ''); // Remove não dígitos
    const length = cleanedValue.length;

    if (length <= 3) {
      return cleanedValue;
    } else if (length <= 6) {
      return `${cleanedValue.slice(0, 3)}.${cleanedValue.slice(3)}`;
    } else if (length <= 9) {
      return `${cleanedValue.slice(0, 3)}.${cleanedValue.slice(3, 6)}.${cleanedValue.slice(6)}`;
    } else if (length <= 11) {
      return `${cleanedValue.slice(0, 3)}.${cleanedValue.slice(3, 6)}.${cleanedValue.slice(6, 9)}-${cleanedValue.slice(
        9
      )}`;
    } else if (length <= 12) {
      return `${cleanedValue.slice(0, 2)}.${cleanedValue.slice(2, 5)}.${cleanedValue.slice(5, 8)}/${cleanedValue.slice(
        8
      )}`;
    } else if (length <= 14) {
      return `${cleanedValue.slice(0, 2)}.${cleanedValue.slice(2, 5)}.${cleanedValue.slice(5, 8)}/${cleanedValue.slice(
        8,
        12
      )}-${cleanedValue.slice(12)}`;
    } else {
      return `${cleanedValue.slice(0, 2)}.${cleanedValue.slice(2, 5)}.${cleanedValue.slice(5, 8)}/${cleanedValue.slice(
        8,
        12
      )}-${cleanedValue.slice(12)}`;
    }
  };

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      // isNumericString
      format={formatCPFOrCNPJ}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      maxLength={18}
      mask="_"
    />
  );
});

export const LatLngMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values: NumberFormatValues) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      decimalSeparator="."
      isNumericString
      decimalScale={20}
      maxLength={30}
    />
  );
});

export const CepMask = React.forwardRef<HTMLInputElement, MaskProps>((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      isNumericString
      format="#####-###"
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      mask="_"
    />
  );
});
